import Vue from "vue";
import App from "./App.vue";

// import tailwind
import "./index.css";

// import fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCheck,
  faSortDown,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faCheck, faSortDown, faSpinner);
Vue.component("fa", FontAwesomeIcon); // init <fa></fa> component

// import axios
import axios from "axios";
import VueAxios from "vue-axios";
axios.defaults.baseURL = "https://saddle-configurator-api.herokuapp.com/"; //axios base url
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount("#app");
